import { Channel, VehicleOwnerType, VehicleRegisteredKeeper, VehicleType } from 'types'

export const showLegalOwnerQuestion = ({
  vehicleType,
  channel,
}: {
  vehicleType: VehicleType | undefined
  channel: Channel | undefined
}) => {
  if (!vehicleType && !channel) {
    return false
  } else if (vehicleType === VehicleType.VAN) {
    return true
  } else if (channel !== Channel.WEB && !!channel) {
    return true
  } else {
    return false
  }
}

/**
 * This checks if the values of the registered keeper are using the newly (smaller scoped) values
 * @param registeredKeeper
 * @returns boolean
 */
export const isAcceptedRegisteredKeeperValue = ({
  registeredKeeper,
}: {
  registeredKeeper: VehicleOwnerType | VehicleRegisteredKeeper | null | undefined
}) => {
  const acceptedValues = Object.keys(VehicleRegisteredKeeper)

  if (!!registeredKeeper && acceptedValues.includes(registeredKeeper)) {
    return true
  }

  return false
}
